export default __webpack_public_path__ + "static/media/user-error.1fbd6a51.svg";